import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useTheme } from 'styled-components';
import { ADMIN_DASHBOARD_HEADER } from '../constants';
import Typography from '../typography/Typography';
import { CustomTHead, Line, Th, Tr } from './styles';
export const TableHeader = ({ headerGroups, borderRadius, hasStickyHeader, headerColor, headerHeight, stickTo = ADMIN_DASHBOARD_HEADER, hasData, }) => {
    const { colors } = useTheme();
    const headerRef = useRef(null);
    useEffect(() => {
        if (!hasStickyHeader || !headerRef.current)
            return;
        const observer = new IntersectionObserver(([entry]) => {
            if (!hasStickyHeader || !headerRef.current)
                return;
            if (entry.isIntersecting) {
                headerRef.current?.classList.remove('pinned');
            }
            else {
                headerRef.current?.classList.add('pinned');
            }
        }, {
            root: null,
            threshold: [0, 1],
            rootMargin: `-${stickTo * 20}px`,
        });
        observer.observe(headerRef.current);
        return () => {
            if (headerRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                observer.unobserve(headerRef.current);
            }
        };
    }, [hasStickyHeader, stickTo]);
    return (_jsxs(CustomTHead, { borderRadius: borderRadius, headerColor: headerColor, headerHeight: headerHeight, hasStickyHeader: hasStickyHeader, stickTo: stickTo, ref: headerRef, children: [headerGroups.map((headerGroup) => {
                const { key, ...rest } = headerGroup.getHeaderGroupProps();
                return (_jsx(Tr, { className: "tableHeader", ...rest, children: headerGroup.headers.map((column, i) => {
                        const { key, ...rest } = column.getHeaderProps();
                        return (_jsx(Th, { className: `${column.id}Th`, "data-cy": `column${i}`, ...rest, children: _jsx(Typography, { type: "bodyButton", fontFamily: "primaryMedium", color: colors.text.secondary, children: column.render('Header') }) }, key));
                    }) }, key));
            }), hasData && (_jsx(Line, { headerHeight: headerHeight, stickTo: stickTo, hasStickyHeader: hasStickyHeader, children: _jsx("th", {}) }))] }));
};
//# sourceMappingURL=TableHeader.js.map